// Generated by purs version 0.13.0
"use strict";
var Control_Applicative = require("../Control.Applicative/index.js");
var Control_Bind = require("../Control.Bind/index.js");
var Data_Argonaut_Core = require("../Data.Argonaut.Core/index.js");
var Data_Argonaut_Decode_Class = require("../Data.Argonaut.Decode.Class/index.js");
var Data_Argonaut_Decode_Combinators = require("../Data.Argonaut.Decode.Combinators/index.js");
var Data_Argonaut_Encode_Class = require("../Data.Argonaut.Encode.Class/index.js");
var Data_Argonaut_Encode_Combinators = require("../Data.Argonaut.Encode.Combinators/index.js");
var Data_Either = require("../Data.Either/index.js");
var Data_Show = require("../Data.Show/index.js");
var Ritoppu_Model_CreatureType = require("../Ritoppu.Model.CreatureType/index.js");
var BasicAI = (function () {
    function BasicAI() {

    };
    BasicAI.value = new BasicAI();
    return BasicAI;
})();
var ConfusedAI = (function () {
    function ConfusedAI(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    ConfusedAI.create = function (value0) {
        return function (value1) {
            return new ConfusedAI(value0, value1);
        };
    };
    return ConfusedAI;
})();
var encodeJsonAiStrategy = new Data_Argonaut_Encode_Class.EncodeJson(function (v) {
    if (v instanceof BasicAI) {
        return Data_Argonaut_Encode_Combinators.extend(Data_Argonaut_Encode_Class.encodeJsonJson)(Data_Argonaut_Encode_Combinators.assoc(Data_Argonaut_Encode_Class.encodeJsonJString)("type")("basic"))(Data_Argonaut_Core.jsonEmptyObject);
    };
    if (v instanceof ConfusedAI) {
        return Data_Argonaut_Encode_Combinators.extend(Data_Argonaut_Encode_Class.encodeJsonJson)(Data_Argonaut_Encode_Combinators.assoc(Data_Argonaut_Encode_Class.encodeJsonJString)("type")("confused"))(Data_Argonaut_Encode_Combinators.extend(Data_Argonaut_Encode_Class.encodeJsonJson)(Data_Argonaut_Encode_Combinators.assoc(Data_Argonaut_Encode_Class.encodeJsonInt)("turns")(v.value0))(Data_Argonaut_Encode_Combinators.extend(Data_Argonaut_Encode_Class.encodeJsonJson)(Data_Argonaut_Encode_Combinators.assoc(encodeJsonAiStrategy)("prevAiStrategy")(v.value1))(Data_Argonaut_Core.jsonEmptyObject)));
    };
    throw new Error("Failed pattern match at Ritoppu.Model.Creature (line 33, column 16 - line 41, column 27): " + [ v.constructor.name ]);
});
var decodeJsonAiStrategy = new Data_Argonaut_Decode_Class.DecodeJson(function (json) {
    return Control_Bind.bind(Data_Either.bindEither)(Data_Argonaut_Decode_Class.decodeJson(Data_Argonaut_Decode_Class.decodeForeignObject(Data_Argonaut_Decode_Class.decodeJsonJson))(json))(function (v) {
        return Control_Bind.bind(Data_Either.bindEither)(Data_Argonaut_Decode_Combinators.getField(Data_Argonaut_Decode_Class.decodeJsonString)(v)("type"))(function (v1) {
            if (v1 === "basic") {
                return Control_Applicative.pure(Data_Either.applicativeEither)(BasicAI.value);
            };
            if (v1 === "confused") {
                return Control_Bind.bind(Data_Either.bindEither)(Data_Argonaut_Decode_Combinators.getField(Data_Argonaut_Decode_Class.decodeJsonInt)(v)("turns"))(function (v2) {
                    return Control_Bind.bind(Data_Either.bindEither)(Data_Argonaut_Decode_Combinators.getField(decodeJsonAiStrategy)(v)("prevAiStrategy"))(function (v3) {
                        return Control_Applicative.pure(Data_Either.applicativeEither)(new ConfusedAI(v2, v3));
                    });
                });
            };
            return new Data_Either.Left("Unknown AiStrategy type " + v1);
        });
    });
});
var creatureName = function (creature) {
    return Data_Show.show(Ritoppu_Model_CreatureType.showCreatureType)(creature.type);
};
module.exports = {
    BasicAI: BasicAI,
    ConfusedAI: ConfusedAI,
    creatureName: creatureName,
    decodeJsonAiStrategy: decodeJsonAiStrategy,
    encodeJsonAiStrategy: encodeJsonAiStrategy
};
